import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M3 5H1v18h18v-2H3V5zm20-4H5v18h18V1zm-2 16H7V3h14v14z"
}), 'FilterNoneSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/FilterNoneSharp.js
// module id = 3658
// module chunks = 2